import { useAxios } from "@/app/providers/AxiosProvider";
import toast from "react-hot-toast";
import slugify from "@lib/helpers/slugify";

export default function useDownloadOriginalCv(candidateId, candidateName) {
  const api = useAxios();

  return async () => {
    const toastId = toast.loading("Downloading CV…");
    try {
      const res = await api.get(`/candidate/${candidateId}/resume/original`, {
        responseType: "blob",
      });

      const disposition = res.headers?.["content-disposition"] ?? "";
      const match = disposition.match(/filename="?([^"]+)"?/i);
      const fallbackName = `cv-${slugify(candidateName) || candidateId}`;
      const filename = match ? match[1] : fallbackName;

      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      toast.success("CV downloaded", { id: toastId });
    } catch (err) {
      console.error("Failed to download original CV:", err);
      toast.error("Failed to download CV", { id: toastId });
    }
  };
}
